export const config = {
   API_BASE_URL: 'https://mymobileapps.cloud/backend',
    //API_BASE_URL: 'http://localhost:4200',

    // Add other configuration values here
  };
  